import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/*
 * Copyright (C) 2020 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
// This is a temporary patch until the All Files panel
// is rewritten to use the files actions that query
// data from the RCS, but still the CanvasContentTray
// know when the FileBrowser is actively querying
// so we can disable the search box in the Filter
import { ALL_FILES_LOADING } from "../actions/all_files.js";
export function allFilesLoading(state = {}, action) {
  if (action.type === ALL_FILES_LOADING) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoading: action.payload
    });
  }

  return state;
}